import styled from 'styled-components';
import { Form as FormElement } from 'formik';

export const Form = styled(FormElement)`
  button {
    margin-top: 1rem;
  }
`;
